<template>
    <div>
        <span class="card-title-top" style="border-bottom: 0;">
            <Row :gutter="16">
                <i-col :xs="8">
                    <span :style="{fontSize: '24px'}">Tickets Finalizados</span>
                    <span :style="{position: 'relative', top: '-4px', left: '8px'}">
                        Exibindo <Badge show-zero type="primary" overflow-count="9999" :count="items_showed" />
                        de <Badge show-zero type="info" overflow-count="9999" :count="filtro.total" />
                    </span>
                </i-col>
                <i-col :xs="15" style="display: flex;align-items: center;">
					<Checkbox v-model="filtro.resolvidos" class="check-resolvido">Resolvidos</Checkbox>
					<Checkbox v-model="filtro.fechados" class="check-fechado">Fechados</Checkbox>
					<i-input search v-model="filtro.search" placeholder="Pesquisar" size="large"></i-input>
					<DatePicker type="daterange" placement="bottom-end" v-model="filtro.periodo" format="dd/MM/yyyy"
                                size="large" style="width: 400px;margin-left:10px;"></DatePicker>
				</i-col>
                <i-col :xs="1"> <Button @click="getTickets('')" icon="ios-refresh" shape="circle"></Button></i-col>
            </Row>
        </span>
        <TicketsTable ref="ticketsTable" :relatores="tickets_pessoas" :analistas="tickets_analistas"
                      :tickets="tickets" @ticketUpdate="onTicketUpdate"
                      exibir-solicitantes exibir-andamento exibir-opcoes :loading="loading"
                      v-if="showTable"></TicketsTable>
    </div>
</template>

<script>
    import reqMixin from "../../mixins/req";
    import _ from "lodash";
    import {moment, toQueryString} from "../../helpers/utils.js";
    import "vue-multiselect/dist/vue-multiselect.min.css";

    export default {
        mixins: [reqMixin],
        components: {
            TicketsTable: () => import("./components/tickets-table.vue")
        },
        name: "tickets-finalizados",
        data() {
            return {
                filtro: {
                    search: "",
                    resolvidos: true,
                    fechados: true,
                    periodo: ["", ""],
                    page: 1,
                    end_page: false,
                    total: 0
                },
                loading: true,
                tickets: [],
                programadores: [],
                pessoas: [],
                items_showed: 0
            };
        },
        computed: {
            showTable() {
                return this.tickets_pessoas.length && this.tickets_analistas.length;
            },
            tickets_pessoas() {
                return this.$store.getters['usuariosAtivos']
                    .map(item => ({
                        value: item.id_pessoa,
                        label: item.nome
                    }));
            },
            tickets_analistas() {
                let analistas = this.$store.getters['analistas']
                    .map(item => ({
                        value: item.id_pessoa,
                        label: item.nome
                    }));
                analistas.unshift({
                    value: null,
                    label: "Não atribuído"
                });
                return analistas;
            }
        },
        watch: {
            'filtro.search'() { this.onFilter() },
            'filtro.periodo'() { this.onFilter() },
            'filtro.abertos'() { this.onFilter() },
            'filtro.fechados'() { this.onFilter() },
            'filtro.resolvidos'() { this.onFilter() },
        },
        methods: {
            onFilter: _.debounce(function () {
                this.getTickets(this.filtro.search, 1);
                this.filtro.page = 1;
                this.filtro.total = 0;
                this.filtro.end_page = false;
            }, 1000),
            async getTickets(query, page = 1) {
                if (!this.filtro.fechados && !this.filtro.resolvidos) {
                    this.tickets = [];
                    return;
                }

                if (!query) {
                    query = "";
                }
                this.loading = true;

                const { source, token } = this.newReq(page);

                try {
                    let URI = `ticket?`;

                    URI += toQueryString({
                        query,
                        page,
                        status: 2,
                        sort: 'data_hora_fechamento',
                        dir: 'desc',
                        ...(this.filtro.periodo[0] && this.filtro.periodo[1] ? {
                            data_inicial: moment(this.filtro.periodo[0]).format('YYYY-MM-DD'),
                            data_final: moment(this.filtro.periodo[1]).format('YYYY-MM-DD'),
                        } : {}),
                        ...((this.filtro.fechados !== this.filtro.resolvidos) ? {
                            andamento: this.filtro.resolvidos ? 7 : 0
                        } : {})
                    });

                    let {data:{data, meta}} = await this.$axios.get(URI, {
                        cancelToken: source.token,
                        headers: {cancelToken: token}
                    });
                    const tickets = data
                        .filter(item => {
                            return item.status == 1 || item.status == 2;
                        }).map(item => {
                            item.solicitantes = item.solicitantes
                                ? JSON.parse(item.solicitantes)
                                : [];
                            return item;
                        });
                    if (page === 1) {
                        this.tickets = tickets;
                    } else {
                        this.tickets = this.tickets.concat(tickets);
                    }
                    /**
                     * Fim da paginação
                     */
                    this.filtro.end_page = (meta.current_page === meta.last_page);
                    this.filtro.total = meta.total;
                    this.loading = false;
                } catch (ex) {
                    if (this.$axios.isCancel(ex)) {
                        const {message: token} = ex;
                        this.$axios.put(`transaction/${token}`);
                    } else {
                        console.warn(ex);
                        this.loading = false;
                    }
                }
            },
            onTicketUpdate(ticket) {
                const idx = this.tickets.findIndex(o => o.id_ticket === ticket.id_ticket);
                this.tickets.splice(idx, 1, ticket);
            },
            /**
             * Responsável pela paginação dos tickets quando alcança o fim da página
             */
            handleScroll: _.debounce(function (e) {
                const el = e.target.documentElement || e.target;
                let windowRelativeBottom = el.scrollHeight - el.offsetHeight;
                if ((el.scrollTop > windowRelativeBottom - 50) && (!this.filtro.end_page)) {
                    this.filtro.page++;
                    this.getTickets(this.filtro.value, this.filtro.page);
                }
            }, 1000),
        },
        created() {
            this.getTickets("", 1);
        },
        mounted() {
            this.el = document.querySelector('#content-area .content-wrapper');
            if (this.el) {
                this.el.addEventListener('scroll', this.handleScroll);
            }
        },
        beforeDestroy() {
            this.el.removeEventListener('scroll', this.handleScroll);
        },
        updated() {
            if (this.$refs.ticketsTable) {
                /**
                 * Verifica a quantidade de tickets que estão sendo filtrados
                 */
                this.$watch(
                    () => {
                        return this.$refs.ticketsTable.items_showed
                    },
                    (val) => {
                        this.items_showed = val;
                    }
                );
            }
        }
    };
</script>

<style>
    .check-resolvido,
    .check-fechado {
        width: 85px;
        display: inline-flex !important;
    }

    .check-resolvido .ivu-checkbox,
    .check-fechado .ivu-checkbox {
        margin-right: 5px;
    }

    .check-resolvido .ivu-checkbox-checked:hover .ivu-checkbox-inner {
        border-color: #00897b;
    }

    .check-resolvido .ivu-checkbox-checked .ivu-checkbox-inner {
        border-color: #00bfa5;
        background-color: #00bfa5;
    }

    .check-fechado .ivu-checkbox-checked:hover .ivu-checkbox-inner {
        border-color: #e53935;
    }

    .check-fechado .ivu-checkbox-checked .ivu-checkbox-inner {
        border-color: #ff5252;
        background-color: #ff5252;
    }
</style>
